
import { computed, defineComponent } from "vue";
import { PDF_CONG_TY_PLACEHOLDER } from "@/components/shared/pdf-viewer/pdf-document-header";

export default defineComponent({
  name: "PdfAccountingHeader",

  props: {
    taiKhoanNo: {
      type: String,
      default: "",
    },
    taiKhoanCo: {
      type: String,
      default: "",
    },
  },

  setup(props) {
    const normalizeAccounting = (value: string) => {
      const trimmed = (value ?? "").trim();
      if (!trimmed || trimmed.toLowerCase() === "không xác định") {
        return PDF_CONG_TY_PLACEHOLDER;
      }
      return trimmed;
    };

    const taiKhoanNoDisplay = computed(() =>
      normalizeAccounting(props.taiKhoanNo)
    );
    const taiKhoanCoDisplay = computed(() =>
      normalizeAccounting(props.taiKhoanCo)
    );

    return {
      taiKhoanNoDisplay,
      taiKhoanCoDisplay,
    };
  },
});
